import Config from "../constantes/Config";
import request from "./request";
import qs from "qs";

const Login = {
  logar: (login, senha) =>
    request.post("/login", qs.stringify({ login, senha }), {
      headers: {
        Authorization: request.basic(Config.API_ID, Config.API_KEY),
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
};

export default Login;



// WEBPACK FOOTER //
// ./src/services/login.js